import { defineStore } from "pinia"
import { ArticleCategoryService } from "@/store/services/articleCategory.service.js"
import { storeToRefs } from "pinia"

export const articleCategoryStore = defineStore("articleCategory", {
  state: () => {
    return {
      articleCategory: "",
    }
  },
  getters: {
    getArticleCategories: (state) => state.articleCategory,
  },
  actions: {
    getArticleCategoriesAction() {
      if (this.articleCategory != "") return this.articleCategory
      EventSys.$emit("articleCategory_loading")
      ArticleCategoryService.list().then(({ data }) => {
        EventSys.$emit("articleCategory_loaded")
        this.articleCategory = data
      })
    },
  },
})
